module.exports = __webpack_public_path__ + "img/tourist.c6591a3f.png";